var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 13.5H11.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.5 10L3.5 10.54L4 7.5L10.73 0.79C10.823 0.696272 10.9336 0.621877 11.0554 0.571109C11.1773 0.52034 11.308 0.494202 11.44 0.494202C11.572 0.494202 11.7027 0.52034 11.8246 0.571109C11.9464 0.621877 12.057 0.696272 12.15 0.79L13.21 1.85C13.3037 1.94296 13.3781 2.05356 13.4289 2.17542C13.4797 2.29728 13.5058 2.42799 13.5058 2.56C13.5058 2.69201 13.4797 2.82272 13.4289 2.94458C13.3781 3.06644 13.3037 3.17704 13.21 3.27L6.5 10Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit_icon.6da845d2e6198f90950ad66da2fd8796.svg";